import { AXIOS } from "../../customAxios";

export async function getSwitchClientsList(clientId: string) {
  return await AXIOS.get(`/api/client/common/switch/userAssignedClients?clientId=${clientId}`);
}